const DomHelper = require('../dom-helper')
const AnalyticsService = require('../../../common/client/analytics')

module.exports = {
  open(elt, opts = { showFFRegisterIncentive: false }) {
    if (typeof elt === 'string') {
      elt = DomHelper.query(elt)
    }
    if (!elt) {
      console.error('could open modal because element not found', elt)
    }
    DomHelper.addClass(elt, 'is-active active')
    if (opts.showFFRegisterIncentive) {
      DomHelper.removeClass(DomHelper.query(elt, '#ffRegisterIncentive'), 'is-hidden')
      AnalyticsService.trackEventSimple('SHOW_REGISTER_INCENTIVE_MODAL')
    } else {
      DomHelper.addClass(DomHelper.query(elt, '#ffRegisterIncentive'), 'is-hidden')
    }
  },
  close(elt) {
    if (typeof elt === 'string') {
      elt = DomHelper.query(elt)
    }
    if (!elt) {
      console.error('could close modal because element not found', elt)
    }
    DomHelper.removeClass(elt, 'is-active active')
  },
}
